import type { Me } from '@turnpilot/contracts';
import { useCallback, useEffect, useState } from 'react';
import { fetchMe, logout } from './api.ts';
import { Login } from './Login.tsx';

/** Racine provisoire de P0 : connexion puis page connectée (remplacée par les vues de la démo à partir de P2). */
export function App() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);
  const refresh = useCallback(() => {
    fetchMe()
      .then(setMe)
      .catch(() => setMe(null));
  }, []);
  useEffect(refresh, [refresh]);

  if (me === undefined) return null;
  if (me === null) return <Login onDone={refresh} />;
  return (
    <main className="tp-home" data-testid="home">
      <h1>Turnpilot</h1>
      <p data-testid="whoami">
        {me.user.displayName} — {me.tenant.name} ({me.role})
      </p>
      <button
        type="button"
        onClick={() => {
          logout().then(() => setMe(null));
        }}
      >
        Se déconnecter
      </button>
    </main>
  );
}
